import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ErrorToastContainer } from '../../function/CustomFunction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPaperPlane,
  faCode,
  faBullhorn,
  faCrosshairs,
  faArrowRight,
  faBolt,
  faCheckCircle,
  faUsers,
  faChartLine,
  faCoins,
  faCloudUploadAlt,
  faFileImport,
  faEdit,
  faCogs,
  faRobot,
  faInfinity,
  faFileExcel
} from '@fortawesome/free-solid-svg-icons';
import './managecampaigns.css';

function BroadcastCampaign() {
  const [selectedType, setSelectedType] = useState('broadcast');
  const messageRetargetingService = useSelector((state) => state?.serviceStore?.value?.message_retargeting);
  const isRetargetingEnabled = Boolean(
    messageRetargetingService && 
    messageRetargetingService !== "0" && 
    messageRetargetingService !== 0
  );

  const campaignTypes = [
    {
      id: 'broadcast',
      title: 'Broadcast Campaign',
      subtitle: 'Broadcast by WhatsApp to every user.',
      subtitleColor: '#075E54',
      description: 'Send messages to your entire audience instantly.',
      icon: faPaperPlane,
      tags: [
        { label: 'Instant Reach', icon: faBolt },
        { label: 'High Delivery', icon: faCheckCircle },
        { label: 'Bulk Messaging', icon: faUsers }
      ]
    },
    {
      id: 'retargeting',
      title: 'Retargeting Campaign',
      subtitle: 'Reach again. Convert better.',
      subtitleColor: '#8b0000',
      description: "Re-engage users who didn't respond to your previous campaigns.",
      icon: faCrosshairs,
      new: true,
      tags: [
        { label: 'Smart Audience', icon: faUsers },
        { label: 'Higher Conversion', icon: faChartLine },
        { label: 'Cost Effective', icon: faCoins }
      ]
    },
    {
      id: 'csv',
      title: 'CSV Broadcast',
      subtitle: 'Send messages from your CSV list.',
      subtitleColor: '#075E54',
      description: 'Upload your audience from CSV & broadcast customized messages.',
      icon: faFileExcel,
      new: true,
      tags: [
        { label: 'CSV Upload', icon: faCloudUploadAlt },
        { label: 'Bulk Import', icon: faFileImport },
        { label: 'Custom Message', icon: faEdit }
      ]
    },
    {
      id: 'api',
      title: 'API Campaign',
      subtitle: 'Automate your WhatsApp messaging.',
      subtitleColor: '#075E54',
      description: 'Integrate via API and automate WhatsApp messaging with your existing systems.',
      icon: faCode,
      tags: [
        { label: 'API Integration', icon: faCogs },
        { label: 'Automation', icon: faRobot },
        { label: 'Developer Friendly', icon: faCode }
      ]
    },
    {
      id: 'meta',
      title: 'Meta Ads',
      subtitle: 'Generate leads from Facebook & Instagram Ads.',
      subtitleColor: '#075E54',
      description: 'Target Click to WhatsApp Ads to your Facebook & Instagram audience to generate leads for retargeting.',
      icon: faBullhorn,
      tags: [
        { label: 'Lead Generation', icon: faUsers },
        { label: 'Ad Integration', icon: faInfinity },
        { label: 'Better ROI', icon: faChartLine }
      ]
    }
  ];

  return (
    <div className="main-panel w-100" style={{ minHeight: '85vh' }}>
      <div className="content-wrapper">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
          <div className="card-body p-4">
            <div className="mb-4 border-bottom pb-3">
              <h3 className="card-title fw-bold text-dark mb-1">Select Campaign Type</h3>
              <p className="text-muted mb-0">Choose how you want to reach your audience with your WhatsApp campaign.</p>
            </div>

            <div className="row g-4 mt-1">
              {campaignTypes.map((campaign) => {
                const isSelected = selectedType === campaign.id;
                const isDisabled = campaign.id === 'retargeting' && !isRetargetingEnabled;

                return (
                  <div className="col-md-6" key={campaign.id}>
                    <div
                      className={`card h-100 cursor-pointer transition-all border-0 shadow-sm position-relative overflow-hidden ${isSelected && !isDisabled ? 'ring-2 ring-success' : ''
                        }`}
                      style={{
                        borderRadius: '16px',
                        border: isSelected && !isDisabled ? '2px solid #075E54' : '1px solid #e2e8f0',
                        backgroundColor: isDisabled ? '#f8fafc' : (isSelected ? '#f0fdf4' : '#ffffff'),
                        opacity: isDisabled ? 0.7 : 1,
                        transition: 'all 0.25s ease'
                      }}
                      onClick={() => {
                        if (isDisabled) {
                          ErrorToastContainer("Your message retargeting feature is not enabled");
                          return;
                        }
                        setSelectedType(campaign.id);
                      }}
                    >
                      {isDisabled ? (
                        <span
                          className="badge text-white px-3 py-1 fw-semibold position-absolute"
                          style={{
                            top: '0',
                            right: '0',
                            backgroundColor: '#64748b',
                            borderTopRightRadius: '14px',
                            borderBottomLeftRadius: '10px',
                            fontSize: '11px',
                            letterSpacing: '0.5px'
                          }}
                        >
                          DISABLED
                        </span>
                      ) : campaign.new && (
                        <span
                          className="badge text-white px-3 py-1 fw-semibold position-absolute"
                          style={{
                            top: '0',
                            right: '0',
                            backgroundColor: '#10b981',
                            borderTopRightRadius: '14px',
                            borderBottomLeftRadius: '10px',
                            fontSize: '11px',
                            letterSpacing: '0.5px'
                          }}
                        >
                          NEW
                        </span>
                      )}

                      <div className="card-body p-4 d-flex flex-column">
                        <div className="d-flex align-items-start gap-3 mb-3">
                          <div
                            className="rounded-circle text-white d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              width: '52px',
                              height: '52px',
                              backgroundColor: isDisabled ? '#64748b' : (isSelected ? '#075E54' : '#005C4B')
                            }}
                          >
                            <FontAwesomeIcon icon={campaign.icon} size="lg" />
                          </div>
                          <div>
                            <h5 className="mb-1 fw-bold text-dark">
                              {campaign.title}
                            </h5>
                            <div className="fw-bold small mb-1" style={{ color: isDisabled ? '#64748b' : campaign.subtitleColor }}>
                              {campaign.subtitle}
                            </div>
                            <p className="text-muted small mb-0" style={{ lineHeight: '1.5', fontSize: '13px' }}>
                              {campaign.description}
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                          <div className="d-flex flex-wrap gap-2">
                            {campaign.tags.map((tag, idx) => (
                              <span
                                key={idx}
                                className="badge bg-white text-secondary border fw-medium px-3 py-2 rounded-pill d-inline-flex align-items-center gap-1"
                                style={{ fontSize: '12px', color: '#475569', borderColor: '#e2e8f0' }}
                              >
                                <FontAwesomeIcon icon={tag.icon} style={{ fontSize: '11px', color: '#64748b' }} />
                                {tag.label}
                              </span>
                            ))}
                          </div>

                          <Link
                            to={`/client-area/whatsapp/campaign/${campaign.id}`}
                            className="btn btn-campaign-primary px-4 py-2 rounded-pill fw-semibold d-inline-flex align-items-center gap-2 ms-auto"
                            style={{
                              opacity: isDisabled ? 0.7 : 1,
                              pointerEvents: isDisabled ? 'none' : 'auto'
                            }}
                            onClick={(e) => {
                              if (isDisabled) {
                                e.preventDefault();
                                ErrorToastContainer("Your message retargeting feature is not enabled");
                              }
                            }}
                          >
                            Next <FontAwesomeIcon icon={faArrowRight} size="sm" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Promo Banner Card: Why Campaigning Tool? */}
              <div className="col-md-6">
                <div
                  className="card h-100 border-0 shadow-sm p-4 d-flex flex-row align-items-center justify-content-between position-relative overflow-hidden"
                  style={{ borderRadius: '16px', backgroundColor: '#eefaf4', border: '1px solid #d1fae5' }}
                >
                  <div className="d-flex flex-column justify-content-between h-100 py-1" style={{ zIndex: 1 }}>
                    <h5 className="fw-bold mb-3" style={{ color: '#075E54' }}>Why Campaigning Tool?</h5>
                    <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                      <li className="d-flex align-items-center gap-2 small fw-medium text-dark">
                        <span className="rounded-circle text-white d-inline-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', backgroundColor: '#10b981', fontSize: '11px' }}>✓</span>
                        Official WhatsApp Business API
                      </li>
                      <li className="d-flex align-items-center gap-2 small fw-medium text-dark">
                        <span className="rounded-circle text-white d-inline-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', backgroundColor: '#10b981', fontSize: '11px' }}>✓</span>
                        100% Secure & Reliable
                      </li>
                      <li className="d-flex align-items-center gap-2 small fw-medium text-dark">
                        <span className="rounded-circle text-white d-inline-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', backgroundColor: '#10b981', fontSize: '11px' }}>✓</span>
                        Better Delivery & Engagement
                      </li>
                      <li className="d-flex align-items-center gap-2 small fw-medium text-dark">
                        <span className="rounded-circle text-white d-inline-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', backgroundColor: '#10b981', fontSize: '11px' }}>✓</span>
                        Smart Retargeting & Analytics
                      </li>
                    </ul>
                  </div>

                  <div className="d-none d-sm-block ps-2" style={{ minWidth: '210px', zIndex: 1 }}>
                    <svg width="220" height="130" viewBox="0 0 220 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <ellipse cx="110" cy="115" rx="90" ry="8" fill="#D1FAE5" fillOpacity="0.8" />

                      <g id="TargetGroup">
                        <circle cx="48" cy="75" r="28" fill="#10B981" fillOpacity="0.15" />
                        <circle cx="48" cy="75" r="24" stroke="#075E54" strokeWidth="4.5" fill="white" />
                        <circle cx="48" cy="75" r="16" stroke="#10B981" strokeWidth="4.5" fill="white" />
                        <circle cx="48" cy="75" r="9" fill="#075E54" />
                        <circle cx="48" cy="75" r="3" fill="white" />

                        <path d="M22 42 L42 62" stroke="#075E54" strokeWidth="4" strokeLinecap="round" />
                        <path d="M20 40 L16 32 M20 40 L28 44" stroke="#075E54" strokeWidth="3" strokeLinecap="round" />
                        <path d="M42 62 L48 62 L44 56 Z" fill="#075E54" />
                      </g>

                      <g id="PhoneGroup">
                        <rect x="92" y="16" width="56" height="96" rx="14" fill="#054E44" stroke="#075E54" strokeWidth="2" />
                        <rect x="96" y="22" width="48" height="84" rx="10" fill="url(#phoneGrad)" />
                        <rect x="112" y="19" width="16" height="3" rx="1.5" fill="#043D35" />

                        <circle cx="120" cy="62" r="16" fill="white" />
                        <path d="M120 49 C112.8 49 107 54.8 107 62 C107 64.6 107.8 67.1 109.1 69.2 L108 73.5 L112.4 72.4 C114.5 73.5 117.2 75 120 75 C127.2 75 133 69.2 133 62 C133 54.8 127.2 49 120 49 Z" fill="#25D366" />
                        <path d="M115.5 56.5 C115 56 114 56 113.5 56.5 C113 57 112.5 58 113 59 C113.5 61 115.5 64.5 119 66.5 C120.5 67.5 122 67.5 123 67 C123.5 66.5 124 65.5 123.5 65 L122 63.5 C121.5 63 120.5 63 120 63.5 L119.5 64 C118 63.5 116.5 62 116 60.5 L116.5 60 C117 59.5 117 58.5 116.5 58 L115.5 56.5 Z" fill="white" />
                      </g>

                      <g id="ChartGroup">
                        <rect x="156" y="82" width="10" height="24" rx="2" fill="#10B981" />
                        <rect x="169" y="72" width="10" height="34" rx="2" fill="#10B981" />
                        <rect x="182" y="60" width="10" height="46" rx="2" fill="#075E54" />
                        <rect x="195" y="46" width="10" height="60" rx="2" fill="#054E44" />

                        <path d="M156 75 Q176 60 205 25" stroke="#075E54" strokeWidth="4" strokeLinecap="round" fill="none" />
                        <polygon points="205,25 195,28 202,36" fill="#075E54" />
                        <circle cx="206" cy="18" r="3.5" fill="#075E54" />
                      </g>

                      <defs>
                        <linearGradient id="phoneGrad" x1="96" y1="22" x2="144" y2="106" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#10B981" />
                          <stop offset="1" stopColor="#054E44" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default BroadcastCampaign;